module.exports = __webpack_public_path__ + "static/img/sunburst.cefe549.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/about/images/sunburst.svg
// module id = Kl68
// module chunks = 1